import React, { useContext, useState } from "react";
import { Grid2, CssBaseline, FormLabel } from "@mui/material";
// import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useFormik } from "formik";
import { Link } from "react-router-dom";
import * as Yup from "yup";
import { Icons } from "../../config/MuiIcons.config";
import AppButton from "../../components/CommonReusableComponent/AppButton/AppButton";
import AppInputField from "../../components/CommonReusableComponent/AppInputField/AppInputField";
import { AppGlobalContext } from "../../contexts/AppContext.context";
import MUIErrorText from "../../components/MUIErrorText/MUIErrorText";
import { IconButton, InputAdornment } from "@mui/material";
import {
  logInWithEmailAndPassword,
  getLoggedInUser,
  firebaseLogOut,
  updateUserPassword,
  // getUserRole,
  getAuthClaims,
  changeLoginStatus,
} from "../../services/authServices/auth.services";
import { useSnackbar } from "../../contexts/Snackbar.context";
import { AUTH_CONFIG } from "../../services/authServices/token.config";
import loginImg from "../../assets/images/login_page_img.png";
// import { useMediaQuery } from "@mui/material";
import {
  FORM_VALIDATIONS,
  LOGIN_AND_FORGOT_PASSWORD,
  // validateEmail,
} from "../../config/Messages.config";
import { ERROR_MESSAGE, SNACKBAR_VARIANT } from "../../config/Messages.config";
import ZingAuditorLogo from "../../assets/images/ZingAuditorFullLogo.svg"
// import { AppTheme } from "../../theme/App.theme";
import { validateEmailField } from "../../common/CommonFunctions";
// import { validateNewPassword } from "../../common/CommonFunctions";
import "./Login-Forgot.Style.css"

const Login = () => {
  document.title = "Login | Zing Auditor";
  const [visibilityForPassword, setVisibilityForPassword] = useState({
    passwordAtLogin: false,
    oldPassword: false,
    newPassword: false,
    confirmPassword: false,
  });
  const [isUserLoggedInForFirstTime, setIsUserLoggedInForFirstTime] =
    useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isPasswordChanged, setIsPasswordChanged] = useState(false);
  const [authUserId, setAuthUserId] = useState(null);
  const { SetAppState } = useContext(AppGlobalContext);
  const { showSnackbar } = useSnackbar();
  // let deviceSize = useMediaQuery("(max-width:700px)");

  const handlePasswordVisibility = (TYPE) => {
    if (TYPE === "passwordAtLogin") {
      setVisibilityForPassword((prev) => ({
        ...prev,
        passwordAtLogin: !prev.passwordAtLogin,
      }));
    } else if (TYPE === "oldPassword") {
      setVisibilityForPassword((prev) => ({
        ...prev,
        oldPassword: !prev.oldPassword,
      }));
    } else if (TYPE === "newPassword") {
      setVisibilityForPassword((prev) => ({
        ...prev,
        newPassword: !prev.newPassword,
      }));
    } else {
      setVisibilityForPassword((prev) => ({
        ...prev,
        confirmPassword: !prev.confirmPassword,
      }));
    }
  };

  // Function to proceed ahead with login details
  const proceedAheadWithAuthDetails = (DATA) => {
    const { reactAppDevAuthUser, setAppStateObject } = DATA;
    // Update AppState
    SetAppState(setAppStateObject);

    // Store user data in localStorage
    localStorage.setItem(
      process.env.REACT_APP_DEV_AUTH_USER,
      JSON.stringify(reactAppDevAuthUser)
    );

    // Stop loading
    setIsLoading(false);
  };

  // Function for login user
  const handleUserLogin = async (email, password) => {
    try {
      const credential = await logInWithEmailAndPassword(email, password);
      const { _tokenResponse, user } = credential;
      AUTH_CONFIG.access_token = _tokenResponse?.idToken;
      AUTH_CONFIG.refresh_token = _tokenResponse?.refreshToken;

      // Retrieve claims and user details
      const claims = await getAuthClaims();
      const userDetails = await getLoggedInUser(user.uid);
      const {
        assignedBranches,
        departmentIds,
        isFirstTimeLogin,
        isLocationIncharge,
        phoneNumber,
        companyName,
        accountId,
        phoneNumberContryCode
      } = userDetails?.data

      // Combine all auth data
      const authDetails = {
        ...user,
        ..._tokenResponse,
        ...claims,
        assignedBranches: assignedBranches,
        departmentIds: departmentIds,
        isFirstTimeLogin: isFirstTimeLogin,
        isLocationIncharge: isLocationIncharge,
        appRoleName: claims?.role,
        loggedInUserPhoneNumber: phoneNumber,
        defaultCountryCode: phoneNumberContryCode,
        companyName: companyName,
        accountId: accountId,
      };

      // Info to save in app state (context API)
      const appStateObject = {
        isAuthUser: authDetails,
        loggedInUserRole: claims?.role,
        assignedBranches: assignedBranches,
        departmentIds: departmentIds,
        isFirstTimeLogin: isFirstTimeLogin,
        isLocationIncharge: isLocationIncharge,
        loggedInUserPhoneNumber: phoneNumber,
        defaultCountryCode: phoneNumberContryCode,
        companyName: companyName,
        accountId: accountId,
      };

      if (isFirstTimeLogin) {
        setIsUserLoggedInForFirstTime(true);
        setIsLoading(false);
        setAuthUserId(user.uid);
      } else {
        const authData = {
          reactAppDevAuthUser: authDetails,
          setAppStateObject: appStateObject,
        };
        proceedAheadWithAuthDetails(authData);
      }
      
    } catch (error) {
      console.error("Login Error: ", error);
      showSnackbar("Invalid Credentials", "error");
      setIsLoading(false);
    }
  };

  const validation = useFormik({
    // enableReinitialize : use this  flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object({
      // .matches(FORM_VALIDATIONS.EMAIL.REGEX, FORM_VALIDATIONS.EMAIL.MESSAGE)
      email: Yup.string()
        .required(FORM_VALIDATIONS.EMAIL.REQUIRED)
        .test("email-validation", "Invalid email", function (value) {
          if (!value) {
            return this.createError({ message: "Email is required" });
          }
          const validationMessage = validateEmailField(value);
          return validationMessage === true
            ? true
            : this.createError({ message: validationMessage });
        }),
      password: Yup.string()
        .matches(
          FORM_VALIDATIONS.PASSWORD.REGEX,
          FORM_VALIDATIONS.PASSWORD.MESSAGE
        )
        .required("Password is required"),
    }),
    onSubmit: (values) => {
      // console.log("Use Details: ", values);
      if (navigator.onLine) {
        setIsLoading(true);
        const { email, password } = values;
        const revisedEmail = email.toLowerCase().trim();
        const revisedPassword = password.trim();
        handleUserLogin(revisedEmail, revisedPassword);
      } else {
        showSnackbar(ERROR_MESSAGE.INTERNET_ERROR, SNACKBAR_VARIANT.ERROR);
      }
    },
  });

  // Function to update/change user password
  const handleChangePasswordFunctionality = async (DATA, ChangePasswordValidation) => {
    const { newPassword } = DATA;
    try {
      await updateUserPassword(newPassword);
      const loginStatus = await changeLoginStatus({
        isFirstTimeLogin: false,
        userId: authUserId,
      });
      const { message, statusCode, success } = loginStatus;
      if (statusCode === 200 && success) {
        showSnackbar(
          message || LOGIN_AND_FORGOT_PASSWORD.CHANGE_PASSWORD,
          SNACKBAR_VARIANT.SUCCESS
        );
        validation.handleReset();
        ChangePasswordValidation?.handleReset();
        firebaseLogOut();
        localStorage.clear();
        setIsUserLoggedInForFirstTime(false);
      }
    } catch (error) {
      console.log("Error during update password: ", error);
    } finally {
      setIsPasswordChanged(false);
    }
  };

  const checkValidationForChangePassword = async (VAlUES) => {
    const { oldPassword, newPassword, confirmPassword } = VAlUES;
    if (oldPassword !== validation.values.password) {
      return {
        message: "Your old password is wrong",
        field: "oldPassword",
      };
    } else if (oldPassword === newPassword) {
      return {
        message: "You cannot set old password as a new password",
        field: "newPassword",
      };
    } else if (newPassword !== confirmPassword) {
      return {
        message: "New password and confirm password should be same",
        field: "confirmPassword",
      };
    } else {
      return false;
    }
  };

  // Change password validation schema
  const changePasswordValidation = useFormik({
    // enableReinitialize : use this  flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
    },
    validationSchema: Yup.object({
      oldPassword: Yup.string()
        .matches(
          FORM_VALIDATIONS.PASSWORD.REGEX,
          FORM_VALIDATIONS.PASSWORD.MESSAGE
        )
        .required("Enter old password"),
      newPassword: Yup.string()
        .min(6, "Password length at least be 6 characters.")
        .matches(
          FORM_VALIDATIONS.PASSWORD.REGEX,
          FORM_VALIDATIONS.PASSWORD.MESSAGE
        )
        // .test("password-validation", "Invalid password", function (value) {
        //   if (!value) {
        //     return this.createError({ message: "Enter new password" });
        //   }
        //   const validationMessage = validateNewPassword(value);
        //   return validationMessage === true
        //     ? true
        //     : this.createError({ message: validationMessage });
        // })
        .required("Enter new password"),
      confirmPassword: Yup.string()
        .min(6, "Password length at least be 6 characters.")
        .matches(
          FORM_VALIDATIONS.PASSWORD.REGEX,
          FORM_VALIDATIONS.PASSWORD.MESSAGE
        )
        .required("Enter new password"),
    }),
    onSubmit: async (values) => {
      // console.log("Password values: ", values);

      if (navigator.onLine) {
        const isValid = await checkValidationForChangePassword(values);
        if (!isValid) {
          setIsPasswordChanged(true);
          handleChangePasswordFunctionality(values, changePasswordValidation);
        } else {
          const { field, message } = isValid;
          changePasswordValidation.setFieldError(field, message);
        }
      } else {
        showSnackbar(ERROR_MESSAGE.INTERNET_ERROR, SNACKBAR_VARIANT.ERROR);
      }
    },
  });

  return (
    <Grid2 container sx={{ height: "100vh" }}>
      <CssBaseline />
      <Grid2
        size={{
          xs: false,
          sm: false,
          md: 6,
        }}
        sx={{
          backgroundImage: `url(${loginImg})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      />
      <Grid2
        size={{
          xs: 12,
          sm: 12,
          md: 6,
        }}
        sx={{
          backgroundColor: "#fff",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          className="login-container"
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div className="d-flex justify-content-center mb-3">
            <img src={ZingAuditorLogo} alt="logo" style={{ height: "35px" }} />
          </div>
          <Typography component="h1" variant="h5">
            {isUserLoggedInForFirstTime ? "Change Password" : "Log In"}
          </Typography>
          {isUserLoggedInForFirstTime && (
            <Typography
              variant="body2"
              className="text-muted inter-regular-400"
            >
              Previous password was system generated. Please change your
              password for security purpose.
            </Typography>
          )}
          {isUserLoggedInForFirstTime ? (
            <form
              // component="form"
              noValidate
              onSubmit={(e) => {
                e.preventDefault();
                changePasswordValidation.handleSubmit();
              }}
              // sx={{ mt: 1 }}
            >
              <Grid2 container>
                <Grid2 size={{ xs: 12 }} className="mt-1">
                  <FormLabel className="inter-regular-400 text-dark my-2">
                    System Generated Password
                  </FormLabel>
                  <AppInputField
                    ClassName="mb-1 inter-regular-400"
                    Size="small"
                    Name="oldPassword"
                    Disabled={isPasswordChanged}
                    Type={
                      !visibilityForPassword.oldPassword ? "password" : "text"
                    }
                    PlaceHolder="Enter Old Password"
                    Id="oldPassword"
                    Value={changePasswordValidation.values.oldPassword || ""}
                    OnChange={changePasswordValidation.handleChange}
                    OnBlur={changePasswordValidation.handleBlur}
                    Error={
                      changePasswordValidation.touched.oldPassword &&
                      changePasswordValidation.errors.oldPassword
                        ? true
                        : false
                    }
                    HelperText={
                      changePasswordValidation.touched.oldPassword &&
                      changePasswordValidation.errors.oldPassword ? (
                        <MUIErrorText
                          ErrorMessage={
                            changePasswordValidation.errors.oldPassword
                          }
                        />
                      ) : null
                    }
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={() =>
                              handlePasswordVisibility("oldPassword")
                            }
                          >
                            {visibilityForPassword.oldPassword ? (
                              <Icons.VisibilityIcon />
                            ) : (
                              <Icons.VisibilityOff />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid2>
                <Grid2 size={{ xs: 12 }} className="mt-1">
                  <FormLabel className="inter-regular-400 text-dark my-2">
                    New Password
                  </FormLabel>
                  <AppInputField
                    ClassName="mb-1 inter-regular-400"
                    Size="small"
                    Name="newPassword"
                    Disabled={isPasswordChanged}
                    Type={
                      !visibilityForPassword.newPassword ? "password" : "text"
                    }
                    PlaceHolder="Enter New Password"
                    Id="newPassword"
                    Value={changePasswordValidation.values.newPassword || ""}
                    OnChange={changePasswordValidation.handleChange}
                    OnBlur={changePasswordValidation.handleBlur}
                    Error={
                      changePasswordValidation.touched.newPassword &&
                      changePasswordValidation.errors.newPassword
                        ? true
                        : false
                    }
                    HelperText={
                      changePasswordValidation.touched.newPassword &&
                      changePasswordValidation.errors.newPassword ? (
                        <MUIErrorText
                          ErrorMessage={
                            changePasswordValidation.errors.newPassword
                          }
                        />
                      ) : null
                    }
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={() =>
                              handlePasswordVisibility("newPassword")
                            }
                          >
                            {visibilityForPassword.newPassword ? (
                              <Icons.VisibilityIcon />
                            ) : (
                              <Icons.VisibilityOff />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid2>
                <Grid2 size={{ xs: 12 }} className="mt-1">
                  <FormLabel className="inter-regular-400 text-dark my-2">
                    Confirm New Password
                  </FormLabel>
                  <AppInputField
                    ClassName="mb-1 inter-regular-400"
                    Size="small"
                    Name="confirmPassword"
                    Disabled={isPasswordChanged}
                    Type={
                      !visibilityForPassword.confirmPassword
                        ? "password"
                        : "text"
                    }
                    PlaceHolder="Enter New Password"
                    Id="confirmPassword"
                    Value={
                      changePasswordValidation.values.confirmPassword || ""
                    }
                    OnChange={changePasswordValidation.handleChange}
                    OnBlur={changePasswordValidation.handleBlur}
                    Error={
                      changePasswordValidation.touched.confirmPassword &&
                      changePasswordValidation.errors.confirmPassword
                        ? true
                        : false
                    }
                    HelperText={
                      changePasswordValidation.touched.confirmPassword &&
                      changePasswordValidation.errors.confirmPassword ? (
                        <MUIErrorText
                          ErrorMessage={
                            changePasswordValidation.errors.confirmPassword
                          }
                        />
                      ) : null
                    }
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={() =>
                              handlePasswordVisibility("confirmPassword")
                            }
                          >
                            {visibilityForPassword.confirmPassword ? (
                              <Icons.VisibilityIcon />
                            ) : (
                              <Icons.VisibilityOff />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid2>
              </Grid2>
              <AppButton
                Type="submit"
                ClassName="inter-regular-400"
                Variant="contained"
                IsDisabled={isPasswordChanged}
                LoadingState={isPasswordChanged}
                SX={{
                  mt: 3,
                  mb: 2,
                  textTransform: "none",
                }}
              >
                Change Password
              </AppButton>
            </form>
          ) : (
            <form
              // component="form"
              noValidate
              onSubmit={(e) => {
                e.preventDefault();
                validation.handleSubmit();
              }}
            >
              <Grid2 container className="my-0 py-0">
                <Grid2 size={{ xs: 12 }} className="mt-1">
                  <FormLabel className="inter-regular-400 text-dark my-2">
                    Email
                  </FormLabel>
                  <AppInputField
                    ClassName="mb-3 inter-regular-400"
                    Size="small"
                    Type="email"
                    Id="email"
                    PlaceHolder="Enter Email"
                    Name="email"
                    Disabled={isLoading}
                    OnChange={validation.handleChange}
                    OnBlur={validation.handleBlur}
                    Value={validation.values.email || ""}
                    Error={
                      validation.touched.email && validation.errors.email
                        ? true
                        : false
                    }
                    HelperText={
                      validation.touched.email && validation.errors.email ? (
                        <MUIErrorText ErrorMessage={validation.errors.email} />
                      ) : null
                    }
                  />
                </Grid2>

                <Grid2 size={{ xs: 12 }} className="mt-1">
                  <FormLabel className="inter-regular-400 text-dark my-2">
                    Password
                  </FormLabel>
                  <AppInputField
                    ClassName="mb-1 inter-regular-400"
                    Size="small"
                    Name="password"
                    Disabled={isLoading}
                    Type={
                      !visibilityForPassword.passwordAtLogin
                        ? "password"
                        : "text"
                    }
                    PlaceHolder="Enter Password"
                    Id="password"
                    Value={validation.values.password || ""}
                    OnChange={validation.handleChange}
                    OnBlur={validation.handleBlur}
                    Error={
                      validation.touched.password && validation.errors.password
                        ? true
                        : false
                    }
                    HelperText={
                      validation.touched.password &&
                      validation.errors.password ? (
                        <MUIErrorText
                          ErrorMessage={validation.errors.password}
                        />
                      ) : null
                    }
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={() =>
                              handlePasswordVisibility("passwordAtLogin")
                            }
                          >
                            {visibilityForPassword.passwordAtLogin ? (
                              <Icons.VisibilityIcon />
                            ) : (
                              <Icons.VisibilityOff />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid2>
              </Grid2>
              <Grid2 container justifyContent={"end"}>
                <Grid2>
                  <Typography
                    variant="body2"
                    className="inter-regular-400"
                    color="text.secondary"
                    align="center"
                  >
                    <Link
                      to={"/forgot-password"}
                      style={{ textDecoration: "none" }}
                      className="ms-1 inter-regular-400 text-muted"
                    >
                      {"Forgot password?"}
                    </Link>
                  </Typography>
                </Grid2>
              </Grid2>
              <AppButton
                Type="submit"
                ClassName="inter-regular-400"
                Variant="contained"
                IsDisabled={isLoading}
                LoadingState={isLoading}
                SX={{
                  mt: 3,
                  mb: 2,
                  textTransform: "none",
                }}
              >
                Log In
              </AppButton>
              <Typography
                variant="body2"
                className="inter-regular-400"
                color="text.secondary"
                align="center"
              >
                {"© "}
                {new Date().getFullYear()} All rights reserved | Powered by{" "}
                <Link
                  to={"https://zingworks.in"}
                  target="_blank"
                  className="text-muted"
                >
                  Zingworks
                </Link>
              </Typography>
            </form>
          )}
        </div>
      </Grid2>
    </Grid2>
  );
};

export default Login;
